/*if a string is mis spelt the your app would break but your compiler will not
be able to find error. so we need to assign it to a const so that if that
variable is mis spelt the compiler will let me knoe. this method helps you
debug the code.
*/

export const CREATE = "CREATE";
export const UPDATE = "UPDATE";
export const LIKE = "LIKE";
export const FETCH_ALL = "FETCH_ALL";
export const DELETE = "DELETE";
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
